module.exports = __webpack_public_path__ + "img/des-6.c47ede36.jpg";